<main>
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" (click)="dialogRef.close()"></i>
    <div class="title-component-box">
        <i *ngIf="type=='alert'" class="fas fa-bell fa-lg"></i>
        <i *ngIf="type=='error'" class="fas fa-exclamation-triangle"></i>
        <h3 class="title-component">{{title}}</h3>
    </div>
    <p class="subtitle-component">
        {{text}}
    </p>
    <hr>
    <app-cargo-list [typeList]="'loadingRoutes'" [modalMode]="true" [modalListFilters]="filters"
        [modalInitialCargos]="cargos" [modalInitialTotal]="total" (navigate)="close()"></app-cargo-list>
</main>
